export default __webpack_public_path__ + "a03035b51b4a9257e6e4c33cec729318.svg";